module.exports = __webpack_public_path__ + "static/media/asset2.ad673f4b.jpg";